const TW_COLOR_MAP: Record<string, string> = {
  'bg-red-400': '#f87171', 'bg-red-500': '#ef4444', 'bg-red-600': '#dc2626',
  'bg-orange-400': '#fb923c', 'bg-orange-500': '#f97316', 'bg-orange-600': '#ea580c',
  'bg-amber-400': '#fbbf24', 'bg-amber-500': '#f59e0b', 'bg-amber-600': '#d97706',
  'bg-yellow-400': '#facc15', 'bg-yellow-500': '#eab308', 'bg-yellow-600': '#ca8a04',
  'bg-lime-400': '#a3e635', 'bg-lime-500': '#84cc16', 'bg-lime-600': '#65a30d',
  'bg-green-400': '#4ade80', 'bg-green-500': '#22c55e', 'bg-green-600': '#16a34a',
  'bg-emerald-400': '#34d399', 'bg-emerald-500': '#10b981', 'bg-emerald-600': '#059669',
  'bg-teal-400': '#2dd4bf', 'bg-teal-500': '#14b8a6', 'bg-teal-600': '#0d9488',
  'bg-cyan-400': '#22d3ee', 'bg-cyan-500': '#06b6d4', 'bg-cyan-600': '#0891b2',
  'bg-sky-400': '#38bdf8', 'bg-sky-500': '#0ea5e9', 'bg-sky-600': '#0284c7',
  'bg-blue-400': '#60a5fa', 'bg-blue-500': '#3b82f6', 'bg-blue-600': '#2563eb',
  'bg-indigo-400': '#818cf8', 'bg-indigo-500': '#6366f1', 'bg-indigo-600': '#4f46e5',
  'bg-violet-400': '#a78bfa', 'bg-violet-500': '#8b5cf6', 'bg-violet-600': '#7c3aed',
  'bg-purple-400': '#c084fc', 'bg-purple-500': '#a855f7', 'bg-purple-600': '#9333ea',
  'bg-fuchsia-400': '#e879f9', 'bg-fuchsia-500': '#d946ef', 'bg-fuchsia-600': '#c026d3',
  'bg-pink-400': '#f472b6', 'bg-pink-500': '#ec4899', 'bg-pink-600': '#db2777',
  'bg-rose-400': '#fb7185', 'bg-rose-500': '#f43f5e', 'bg-rose-600': '#e11d48',
  'bg-gray-300': '#d1d5db', 'bg-gray-400': '#9ca3af', 'bg-gray-500': '#6b7280',
  'bg-gray-600': '#4b5563',
}

export function twColorToHex(twClass: string): string {
  return TW_COLOR_MAP[twClass] ?? '#6366f1'
}

export const COLOR_OPTIONS = [
  { label: 'Red', value: 'bg-red-500', hex: '#ef4444' },
  { label: 'Orange', value: 'bg-orange-500', hex: '#f97316' },
  { label: 'Amber', value: 'bg-amber-500', hex: '#f59e0b' },
  { label: 'Green', value: 'bg-green-500', hex: '#22c55e' },
  { label: 'Emerald', value: 'bg-emerald-500', hex: '#10b981' },
  { label: 'Teal', value: 'bg-teal-500', hex: '#14b8a6' },
  { label: 'Sky', value: 'bg-sky-500', hex: '#0ea5e9' },
  { label: 'Blue', value: 'bg-blue-500', hex: '#3b82f6' },
  { label: 'Indigo', value: 'bg-indigo-500', hex: '#6366f1' },
  { label: 'Violet', value: 'bg-violet-500', hex: '#8b5cf6' },
  { label: 'Purple', value: 'bg-purple-500', hex: '#a855f7' },
  { label: 'Pink', value: 'bg-pink-500', hex: '#ec4899' },
  { label: 'Rose', value: 'bg-rose-500', hex: '#f43f5e' },
  { label: 'Gray', value: 'bg-gray-300', hex: '#d1d5db' },
  { label: 'Indigo 600', value: 'bg-indigo-600', hex: '#4f46e5' },
  { label: 'Green 600', value: 'bg-green-600', hex: '#16a34a' },
]
